module.exports = __webpack_public_path__ + "img/html-evolution-1.6e00b23c.jpg";